/**
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import Vue from 'vue'
import { api_postLogin, api_getLogout } from '@/api/user'
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from '@/utils/accessToken'
import { setStorage, removeStorage } from '@/utils/index'
import { resetRouter } from '@/router'
import { title, tokenName } from '@/config'

const state = () => ({
  accessToken: getAccessToken(),
  username: '',
  avatar: '',
  permissions: [],
  dialogShow: false,
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  permissions: (state) => state.permissions,
  dialogShow: (state) => state.dialogShow,
}
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  setUsername(state, username) {
    state.username = username
  },
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
  },
  setDialogShow(state, dialogShow) {
    state.dialogShow = dialogShow
  },
}
const actions = {
  setDialogShow({ commit }, dialogShow) {
    commit('setDialogShow', dialogShow)
  },
  setPermissions({ commit }, permissions) {
    commit('setPermissions', permissions)
  },
  async login({ commit }, userInfo) {
    let data = await api_postLogin(userInfo)
    data.authBtn = data.permissions
    let permissions = []
    data.menus.forEach(item => {
      item.children && item.children.forEach(el => {
        permissions.push(el.path)
      })
      permissions.push(item.path)
      item.path === '/' && permissions.push('/index')
    })

    data.permissions = permissions
    setStorage('USER_INFO', data)
    const accessToken = data[tokenName]
    if (accessToken) {
      commit('setAccessToken', accessToken)
      commit('setPermissions', data.permissions)
      setStorage('USER_PERMISSIONS', data.permissions)
      setStorage('USER_BUTTON_AUTH', data.authBtn)
      setStorage('account', data[tokenName])
      const hour = new Date().getHours()
      const thisTime =
        hour < 8
          ? '早上好'
          : hour <= 11
          ? '上午好'
          : hour <= 13
          ? '中午好'
          : hour < 18
          ? '下午好'
          : '晚上好'
      Vue.prototype.$baseNotify(`欢迎登录${title}`, `${thisTime}！`)
    } else {
      Vue.prototype.$baseMessage(
        `登录接口异常，未正确返回${tokenName}...`,
        'error'
      )
    }
  },
  async getUserInfo({ commit, state }) {
    // const { data } = await getUserInfo(state.accessToken)
    // const data = {
    //   avatar: "https://i.gtimg.cn/club/item/face/img/2/15922_100.gif",
    //   permissions: ["admin"],
    //   username: "admin"
    // }
    // if (!data) {
    //   Vue.prototype.$baseMessage('验证失败，请重新登录...', 'error')
    //   return false
    // }
    // let { permissions, username, avatar } = data
    // if (permissions && username && Array.isArray(permissions)) {
    //   commit('setPermissions', permissions)
    //   commit('setUsername', username)
    //   commit('setAvatar', avatar)
    //   return permissions
    // } else {
    //   Vue.prototype.$baseMessage('用户信息接口异常', 'error')
    //   return false
    // }
  },
  async logout({ dispatch }, goApi) {
    if (!goApi) {
      await api_getLogout()
    }
    removeStorage('USER_INFO')
    removeStorage('USER_PERMISSIONS')
    removeStorage('USER_BUTTON_AUTH')
    await dispatch('resetAccessToken')
    // await resetRouter()
  },
  resetAccessToken({ commit }) {
    commit('setPermissions', [])
    commit('setAccessToken', '')
    // removeAccessToken()
  },
}
export default { state, getters, mutations, actions }
